import React from "react"
import ReactDOM from "react-dom"
import ContentBannerIcon from "./content-banner-icon"

export default class ContentBannerIconModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ContentBannerIcon {...self.modelJson} />, self.elem)
  }
}
